module.exports = __webpack_public_path__ + "static/media/ladies_raise_hands.03f5bcd8.png";